import { useState, createContext, useContext } from 'react';

// Create context
export const dataContext = createContext();

// Mock data
const mockUsers = [
  { id: 1, name: 'Alice', email: 'alice@example.com' },
  { id: 2, name: 'Bob', email: 'bob@example.com' }
];

const mockItems = [
  { id: 1, title: 'Item One', description: 'First item' },
  { id: 2, title: 'Item Two', description: 'Second item' }
];

// Provider hook
export const useProvideData = () => {
  const [users, setUsers] = useState(mockUsers);
  const [items, setItems] = useState(mockItems);
  const [isLoading, setIsLoading] = useState(false);

  // Functions
  const addUser = (user) => {
    setUsers(prev => [...prev, { ...user, id: Date.now() }]);
  };

  const removeUser = (id) => {
    setUsers(prev => prev.filter(user => user.id !== id));
  };

  const addItem = (item) => {
    setItems(prev => [...prev, { ...item, id: Date.now() }]);
  };

  const removeItem = (id) => {
    setItems(prev => prev.filter(item => item.id !== id));
  };

  const clearItems = () => {
    setItems([]);
  };

  return {
    users,
    items,
    isLoading,
    setIsLoading,
    addUser,
    removeUser,
    addItem,
    removeItem,
    clearItems
  };
};

// Provider component
export function ProvideData({ children }) {
  const data = useProvideData();
  return <dataContext.Provider value={data}>{children}</dataContext.Provider>;
}

// Hook for components
export const useData = () => {
  return useContext(dataContext);
};

